import classNames from 'classnames';
import { ChangeEventHandler, FC, PropsWithChildren } from 'react';

import { UnionIcon } from '@gem/icons';
import { popupItemStyles } from '@gem/ui-kit';

import styles from './CheckboxRow.styles.m.scss';

interface ICheckboxRowProps {
  onClick?: ChangeEventHandler<HTMLInputElement>;
  isSelected: boolean;
  isDisabled?: boolean;
}

export const CheckboxRow: FC<PropsWithChildren<ICheckboxRowProps>> = (props) => {
  const { onClick, isSelected, children, isDisabled } = props;

  return (
    <label
      className={classNames(
        popupItemStyles.container,
        popupItemStyles.interactive,
        styles.container,
        {
          [styles.disabled]: isDisabled,
        }
      )}
    >
      {children}
      <input
        type="checkbox"
        className={styles.checkbox}
        checked={isSelected}
        onChange={onClick}
      />
      <div className={styles.checkboxView}>{isSelected && <UnionIcon />}</div>
    </label>
  );
};
